<div class="stator-wrap">

  <div class="stator-header">
    <h2>PCB Stator Generator</h2>
    <p class="stator-subtitle">{{ params.numCoils }}-coil, {{ params.numPhases }}-phase {{ coilShape === 'wedge' ? 'wedge' : 'concentrated spiral' }} winding — {{ turnsPerLayer }} turns/coil — axial flux motor</p>
  </div>

  <div class="stator-layout">

    <!-- ══════════════════════════════════════════════════════════
         Parameter Panel
    ═══════════════════════════════════════════════════════════ -->
    <div class="params-panel">

      <div class="tab-bar">
        <button class="tab-btn" [class.active]="activeTab === 'stator'" (click)="setActiveTab('stator')">Stator</button>
        <button class="tab-btn" [class.active]="activeTab === 'rotor'" (click)="setActiveTab('rotor')">Rotor</button>
        <button class="tab-btn" [class.active]="activeTab === 'encoder'" (click)="setActiveTab('encoder')">Encoder</button>
      </div>

      <ng-container *ngIf="activeTab === 'stator'">
        <div class="param-section">
          <button type="button" class="param-section-title accordion-toggle" (click)="toggleSection('board')">
            <span class="chevron">{{ sectionCollapsed.board ? '&#9656;' : '&#9662;' }}</span> Board
          </button>
          <ng-container *ngIf="!sectionCollapsed.board">
        <div class="param-row">
          <label class="param-label">Inner Radius
            <span class="help-i" [ngbTooltip]="help('innerRadius')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="params.innerRadius" min="5" max="200" step="1" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Outer Radius
            <span class="help-i" [ngbTooltip]="help('outerRadius')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="params.outerRadius" min="10" max="300" step="1" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Outer margin
            <span class="help-i" [ngbTooltip]="help('outerMargin')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="params.outerMargin" min="0" max="30" step="0.5" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Inner margin
            <span class="help-i" [ngbTooltip]="help('innerMargin')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="params.innerMargin" min="0" max="30" step="0.5" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row" *ngIf="!marginsValid">
          <span class="warn-badge">&#9888; margins too small — each needs ≥ 2×clearance + (numPhases+1)×(traceWidth+clearance)</span>
        </div>
        <div class="param-row">
          <label class="param-label">Coils
            <span class="help-i" [ngbTooltip]="help('numCoils')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="params.numCoils" [min]="params.numPhases" max="24" [step]="params.numPhases" class="param-input">
          </div>
        </div>
        <div class="param-row" *ngIf="!numCoilsValid">
          <span class="warn-badge">&#9888; coils must be multiple of phases</span>
        </div>
        <div class="param-row">
          <label class="param-label">Phases
            <span class="help-i" [ngbTooltip]="help('numPhases')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="params.numPhases" min="1" max="6" step="1" class="param-input">
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Poles (ref)
            <span class="help-i" [ngbTooltip]="help('numPoles')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="params.numPoles" min="2" max="24" step="2" class="param-input">
            <span class="unit">(mag)</span>
          </div>
        </div>
        <div class="param-row pole-chips" *ngIf="poleOptions.length">
          <span class="pole-chips-label">try:
            <span class="help-i" [ngbTooltip]="help('polePairing')" container="body">&#9432;</span>
          </span>
          <button *ngFor="let o of poleOptions"
                  class="layer-btn pole-chip"
                  [class.active]="params.numPoles === o.poles"
                  [ngbTooltip]="'winding factor ' + (o.windingFactor | number:'1.2-2')" container="body"
                  (click)="setPoles(o.poles)">{{ o.poles }}</button>
        </div>
          </ng-container>
        </div>

        <div class="param-section">
          <button type="button" class="param-section-title accordion-toggle" (click)="toggleSection('coil')">
            <span class="chevron">{{ sectionCollapsed.coil ? '&#9656;' : '&#9662;' }}</span> Coil
          </button>
          <ng-container *ngIf="!sectionCollapsed.coil">
        <div class="param-row">
          <label class="param-label">Trace width
            <span class="help-i" [ngbTooltip]="help('traceWidth')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="params.traceWidth" min="0.1" max="3" step="0.05" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Clearance
            <span class="help-i" [ngbTooltip]="help('traceClearance')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="params.traceClearance" min="0.1" max="3" step="0.05" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Temp rise
            <span class="help-i" [ngbTooltip]="help('deltaTempC')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="deltaTempC" min="1" step="5" class="param-input">
            <span class="unit">&deg;C</span>
          </div>
        </div>
        <div class="param-row" *ngIf="!turnsValid">
          <span class="warn-badge">&#9888; too few turns — increase radial depth or decrease trace pitch</span>
        </div>
          </ng-container>
        </div>

        <div class="param-section">
          <button type="button" class="param-section-title accordion-toggle" (click)="toggleSection('stack')">
            <span class="chevron">{{ sectionCollapsed.stack ? '&#9656;' : '&#9662;' }}</span> PCB Stack
          </button>
          <ng-container *ngIf="!sectionCollapsed.stack">
        <div class="param-row">
          <label class="param-label">Winding
            <span class="help-i" [ngbTooltip]="help('windingType')" container="body">&#9432;</span>
          </label>
          <div class="layer-toggle">
            <button class="layer-btn" [class.active]="windingType === 'wye'"   (click)="windingType = 'wye'">Wye (Y)</button>
            <button class="layer-btn" [class.active]="windingType === 'delta'" (click)="windingType = 'delta'">Delta (&#916;)</button>
            <button class="layer-btn" [class.active]="windingType === 'independent'" (click)="windingType = 'independent'">Independent (6-lead)</button>
          </div>
        </div>
        <div class="param-row" *ngIf="configSupport.level !== 'verified'">
          <span class="warn-badge" [class.warn-broken]="configSupport.level === 'broken'">
            &#9888; {{ configSupport.level === 'broken' ? 'Known broken' : 'Not DRC-verified' }}
            <span class="help-i" [ngbTooltip]="help('configSupport')" container="body">&#9432;</span>
          </span>
          <ul class="support-reasons">
            <li *ngFor="let r of configSupport.reasons">{{ r.text }}</li>
          </ul>
        </div>
        <div class="param-row">
          <label class="param-label">Coil shape
            <span class="help-i" [ngbTooltip]="help('coilShape')" container="body">&#9432;</span>
          </label>
          <div class="layer-toggle">
            <button class="layer-btn" [class.active]="coilShape === 'spiral'" (click)="coilShape = 'spiral'">Spiral</button>
            <button class="layer-btn" [class.active]="coilShape === 'wedge'" (click)="coilShape = 'wedge'">Wedge</button>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Terminal
            <span class="help-i" [ngbTooltip]="help('terminalStyle')" container="body">&#9432;</span>
          </label>
          <div class="layer-toggle">
            <button class="layer-btn" [class.active]="terminalStyle === 'solder'" (click)="terminalStyle = 'solder'">Solder</button>
            <button class="layer-btn" [class.active]="terminalStyle === 'wire'" (click)="terminalStyle = 'wire'">Wire</button>
            <button class="layer-btn" [class.active]="terminalStyle === 'screw'" (click)="terminalStyle = 'screw'">Screw</button>
          </div>
        </div>
        <div class="param-row" *ngIf="terminalStyle !== 'solder'">
          <span class="param-helper">Wire/Screw terminals are larger &mdash; the crowded inner margin may need more room; run the DRC to confirm clearance.</span>
        </div>
        <div class="param-row">
          <label class="param-label">Terminal layout
            <span class="help-i" [ngbTooltip]="help('terminalLayout')" container="body">&#9432;</span>
          </label>
          <div class="layer-toggle">
            <button class="layer-btn" [class.active]="terminalLayout === 'adjacent'"
                    (click)="terminalLayout = 'adjacent'">Adjacent</button>
            <button class="layer-btn" [class.active]="terminalLayout === 'stacking-tabs'"
                    [disabled]="windingType !== 'independent'"
                    [ngbTooltip]="windingType !== 'independent'
                      ? 'Stacking tabs is only available with Independent (6-lead) winding.'
                      : help('terminalLayout')"
                    container="body"
                    (click)="terminalLayout = 'stacking-tabs'">Stacking tabs</button>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Mounting holes
            <span class="help-i" [ngbTooltip]="help('mountingHoles')" container="body">&#9432;</span>
          </label>
          <input type="number" [(ngModel)]="mountingHoles" min="0" max="12" step="1" class="param-input">
        </div>
        <ng-container *ngIf="mountingHoles > 0">
          <div class="param-row">
            <label class="param-label">Screw size
              <span class="help-i" [ngbTooltip]="help('mountingScrew')" container="body">&#9432;</span>
            </label>
            <div class="layer-toggle">
              <button class="layer-btn" [class.active]="mountingScrew === 'M2'"   (click)="mountingScrew = 'M2'">M2</button>
              <button class="layer-btn" [class.active]="mountingScrew === 'M2.5'" (click)="mountingScrew = 'M2.5'">M2.5</button>
              <button class="layer-btn" [class.active]="mountingScrew === 'M3'"   (click)="mountingScrew = 'M3'">M3</button>
              <button class="layer-btn" [class.active]="mountingScrew === 'M4'"   (click)="mountingScrew = 'M4'">M4</button>
            </div>
          </div>
          <div class="param-row">
            <label class="param-label">Bolt-circle radius (mm)
              <span class="help-i" [ngbTooltip]="help('mountingBoltRadius')" container="body">&#9432;</span>
            </label>
            <input type="number" [(ngModel)]="mountingBoltRadius" min="1" [max]="params.outerRadius" step="0.5" class="param-input">
          </div>
          <div class="param-row" *ngIf="!mountingHolesValid">
            <span class="warn-badge">&#9888; Holes (keepout) cross a board edge &mdash; reduce count or move the bolt circle inward.</span>
          </div>
        </ng-container>
        <div class="param-row">
          <label class="param-label">Layers
            <span class="help-i" [ngbTooltip]="help('numLayers')" container="body">&#9432;</span>
          </label>
          <div class="layer-toggle">
            <button class="layer-btn" [class.active]="params.numLayers === 4" (click)="setNumLayers(4)">4L</button>
            <button class="layer-btn" [class.active]="params.numLayers === 6" (click)="setNumLayers(6)">6L</button>
            <button class="layer-btn" [class.active]="params.numLayers === 8" (click)="setNumLayers(8)">8L</button>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Copper
            <span class="help-i" [ngbTooltip]="help('copperOz')" container="body">&#9432;</span>
          </label>
          <div class="layer-toggle">
            <button class="layer-btn" [class.active]="params.copperOz === 1" (click)="params.copperOz = 1">1 oz</button>
            <button class="layer-btn" [class.active]="params.copperOz === 2" (click)="params.copperOz = 2">2 oz</button>
          </div>
        </div>
          </ng-container>
        </div>

      <div class="phase-legend">
        <div class="legend-title">Phases</div>
        <div class="legend-items">
          <div *ngFor="let i of phaseIndices()" class="legend-item">
            <span class="legend-dot" [style.background]="phaseColors[i]"></span>
            <span class="legend-label">{{ phaseLabels[i] }}</span>
          </div>
        </div>
      </div>

      <div class="export-row">
        <button class="export-btn" (click)="downloadGerbers()" [disabled]="isGenerating">
          {{ isGenerating ? 'Generating...' : 'Download Gerbers' }}
        </button>
        <span class="export-note">JLCPCB-compatible ZIP</span>
      </div>
      </ng-container>

      <ng-container *ngIf="activeTab === 'rotor'">
        <div class="param-section">
          <button type="button" class="param-section-title accordion-toggle" (click)="toggleSection('magnets')">
            <span class="chevron">{{ sectionCollapsed.magnets ? '&#9656;' : '&#9662;' }}</span> Magnets
          </button>
          <ng-container *ngIf="!sectionCollapsed.magnets">

        <ng-container *ngIf="!magnetData.warning; else magnetWarn">
          <div class="stat-row">
            <span class="stat-label">Count</span>
            <span class="stat-value">{{ magnetData.count }}</span>
          </div>
          <div class="stat-row">
            <span class="stat-label">Placement radius</span>
            <span class="stat-value">{{ magnetData.meanRadiusMm | number:'1.1-1' }} mm</span>
          </div>
          <div class="stat-row">
            <span class="stat-label">Pole pitch</span>
            <span class="stat-value">{{ magnetData.poleArcMm | number:'1.1-1' }} mm</span>
          </div>

          <div class="magnet-rec" *ngFor="let opt of magnetData.options">
            <span class="magnet-shape">{{ magnetShapeLabel(opt) }}</span>
            <span class="magnet-size">{{ magnetStandardLabel(opt) }}</span>
            <span class="magnet-meta">{{ magnetMaxLabel(opt) }} &middot; {{ opt.coveragePct | number:'1.0-0' }}% fill</span>
          </div>

          <div class="param-row" *ngIf="magnetCatalogCapHint as hint">
            <span class="warn-badge">&#9888; {{ hint }}</span>
          </div>

          <p class="param-helper">Thickness: pick &ge; air gap; 2&ndash;3 mm typical.</p>
        </ng-container>

        <ng-template #magnetWarn>
          <div class="param-row">
            <span class="warn-badge">&#9888; {{ magnetData.warning }}</span>
          </div>
        </ng-template>
          </ng-container>
        </div>

        <div class="param-section">
          <button type="button" class="param-section-title accordion-toggle" (click)="toggleSection('rotor')">
            <span class="chevron">{{ sectionCollapsed.rotor ? '&#9656;' : '&#9662;' }}</span> Rotor
          </button>
          <ng-container *ngIf="!sectionCollapsed.rotor">
        <div class="param-row">
          <label class="param-label">Magnet shape
            <span class="help-i" [ngbTooltip]="help('rotorMagnetShape')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <button class="layer-btn" [class.active]="rotorMagnetShape === 'round'" (click)="rotorMagnetShape = 'round'">Round</button>
            <button class="layer-btn" [class.active]="rotorMagnetShape === 'rect'"  (click)="rotorMagnetShape = 'rect'">Rect</button>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Magnet thickness
            <span class="help-i" [ngbTooltip]="help('rotorMagnetThickness')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="rotorMagnetThicknessMm" min="0.5" max="20" step="0.5" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Disc thickness
            <span class="help-i" [ngbTooltip]="help('rotorDiscThickness')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="rotorDiscThicknessMm" min="0.5" max="20" step="0.5" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Bore diameter
            <span class="help-i" [ngbTooltip]="help('rotorBoreDiameter')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="rotorBoreDiameterMm" min="0" max="50" step="0.5" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Pocket clearance
            <span class="help-i" [ngbTooltip]="help('rotorPocketClearance')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="rotorPocketClearanceMm" min="0" max="1" step="0.05" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row" *ngIf="rotorLayout.valid">
          <span class="stat-label">Disc</span>
          <span class="stat-value">R{{ rotorLayout.discOuterRadiusMm | number:'1.1-1' }} &times; {{ rotorLayout.thicknessMm | number:'1.1-1' }} mm — {{ rotorLayout.magnets.length }} magnets</span>
        </div>
        <div class="param-row" *ngIf="!rotorLayout.valid">
          <span class="warn-badge">&#9888; {{ rotorLayout.warning }}</span>
        </div>
          </ng-container>
        </div>

        <div class="param-section">
          <button type="button" class="param-section-title accordion-toggle" (click)="toggleSection('generator')">
            <span class="chevron">{{ sectionCollapsed.generator ? '&#9656;' : '&#9662;' }}</span> Generator
          </button>
          <ng-container *ngIf="!sectionCollapsed.generator">
        <div class="param-row">
          <label class="param-label">Air-gap flux
            <span class="help-i" [ngbTooltip]="help('airGapT')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="airGapT" min="0.05" step="0.05" class="param-input">
            <span class="unit">T</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Speed
            <span class="help-i" [ngbTooltip]="help('genRpm')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="genRpm" min="0" step="500" class="param-input">
            <span class="unit">rpm</span>
          </div>
        </div>
          </ng-container>
        </div>

        <div class="export-row">
          <button class="export-btn" [disabled]="!rotorLayout.valid" (click)="downloadRotorStl()">Download rotor .stl</button>
        </div>
      </ng-container>

      <ng-container *ngIf="activeTab === 'encoder'">
        <div class="param-section">
          <button type="button" class="param-section-title accordion-toggle" (click)="toggleSection('sensor')">
            <span class="chevron">{{ sectionCollapsed.sensor ? '&#9656;' : '&#9662;' }}</span> Sensor
          </button>
          <ng-container *ngIf="!sectionCollapsed.sensor">
        <div class="param-row">
          <label class="param-label">Enable encoder
            <span class="help-i" [ngbTooltip]="help('encoderEnabled')" container="body">&#9432;</span>
          </label>
          <div class="layer-toggle">
            <button class="layer-btn" [class.active]="!encoderEnabled" (click)="setEncoderEnabled(false)">Off</button>
            <button class="layer-btn" [class.active]="encoderEnabled" (click)="setEncoderEnabled(true)">On</button>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Bore radius
            <span class="help-i" [ngbTooltip]="help('encoderBoreRadius')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="encoderParams.boreRadiusMm" min="1" max="30" step="0.5" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Trace width
            <span class="help-i" [ngbTooltip]="help('encoderTraceWidth')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="encoderParams.traceWidthMm" min="0.1" max="1" step="0.05" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Clearance
            <span class="help-i" [ngbTooltip]="help('encoderClearance')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="encoderParams.clearanceMm" min="0.1" max="1" step="0.05" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">RX turns
            <span class="help-i" [ngbTooltip]="help('encoderRxTurns')" container="body">&#9432;</span>
          </label>
          <input type="number" [(ngModel)]="encoderParams.rxTurns" min="1" max="4" step="1" class="param-input">
        </div>
        <div class="param-row">
          <label class="param-label">Hub radius
            <span class="help-i" [ngbTooltip]="help('encoderHubRadius')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="encoderParams.hubRadiusMm" min="1" max="30" step="0.5" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Target thickness
            <span class="help-i" [ngbTooltip]="help('encoderTargetThickness')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="encoderParams.targetThicknessMm" min="0.1" max="3" step="0.1" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="param-row">
          <label class="param-label">Sensing gap
            <span class="help-i" [ngbTooltip]="help('encoderSensingGap')" container="body">&#9432;</span>
          </label>
          <div class="param-input-wrap">
            <input type="number" [(ngModel)]="encoderParams.sensingGapMm" min="0.1" max="5" step="0.1" class="param-input">
            <span class="unit">mm</span>
          </div>
        </div>
        <div class="stat-row">
          <span class="stat-label">Fine periodicity (numPoles/2)
            <span class="help-i" [ngbTooltip]="help('encoderFinePeriodicity')" container="body">&#9432;</span></span>
          <span class="stat-value">{{ finePeriodicity }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Chip fine/coarse periods</span>
          <span class="stat-value">{{ encoderPeriods.fine }} / {{ encoderPeriods.coarse }}</span>
        </div>
        <ng-container *ngIf="encoderBands.valid; else bandsInvalid">
          <div class="stat-row">
            <span class="stat-label">Coarse track</span>
            <span class="stat-value">R{{ encoderBands.coarse.rInMm | number:'1.1-1' }}&ndash;{{ encoderBands.coarse.rOutMm | number:'1.1-1' }} mm</span>
          </div>
          <div class="stat-row">
            <span class="stat-label">Fine track</span>
            <span class="stat-value">R{{ encoderBands.fine.rInMm | number:'1.1-1' }}&ndash;{{ encoderBands.fine.rOutMm | number:'1.1-1' }} mm</span>
          </div>
          <div class="stat-row">
            <span class="stat-label">TX allocation</span>
            <span class="stat-value">R{{ encoderBands.tx.rInMm | number:'1.1-1' }}&ndash;{{ encoderBands.tx.rOutMm | number:'1.1-1' }} mm</span>
          </div>
        </ng-container>
        <ng-template #bandsInvalid>
          <div class="param-row">
            <span class="warn-badge warn-broken">&#9888; Sensing geometry does not fit</span>
          </div>
        </ng-template>
          </ng-container>
        </div>

        <div class="param-section" *ngIf="encoderEnabled">
          <button type="button" class="param-section-title accordion-toggle" (click)="toggleSection('boards')">
            <span class="chevron">{{ sectionCollapsed.boards ? '&#9656;' : '&#9662;' }}</span> Boards
          </button>
          <ng-container *ngIf="!sectionCollapsed.boards">
        <div class="stat-row">
          <span class="stat-label">Chip</span>
          <span class="stat-value">RAA2P3226 (TSSOP-16)</span>
        </div>
        <div class="param-row" *ngFor="let r of encoderSupport.reasons">
          <span class="warn-badge" [class.warn-broken]="r.level === 'broken'">&#9888; {{ r.text }}</span>
        </div>
        <div class="param-row">
          <button type="button" class="layer-btn" [disabled]="encoderBoardBusy" (click)="ensureEncoderBoard()">
            {{ encoderBoardBusy ? 'Solving routing…' : (encoderBoard ? 'Re-solve routing' : 'Solve routing') }}
          </button>
        </div>
        <div class="stat-row" *ngIf="encoderBoard">
          <span class="stat-label">Routing</span>
          <span class="stat-value" [class.stat-warn]="!encoderBoard.valid">{{ encoderBoard.valid ? 'clean' : 'FAILED' }}</span>
        </div>
          </ng-container>
        </div>

        <div class="param-section" *ngIf="encoderEnabled">
          <button type="button" class="param-section-title accordion-toggle" (click)="toggleSection('downloads')">
            <span class="chevron">{{ sectionCollapsed.downloads ? '&#9656;' : '&#9662;' }}</span> Downloads
          </button>
          <ng-container *ngIf="!sectionCollapsed.downloads">
        <div class="export-row">
          <button class="export-btn" [disabled]="isGenerating" (click)="downloadEncoderRing()">
            {{ isGenerating ? 'Generating...' : 'Download encoder-ring gerbers' }}
          </button>
        </div>
        <div class="export-row">
          <button class="export-btn" [disabled]="isGenerating" (click)="downloadTargetRing()">
            {{ isGenerating ? 'Generating...' : 'Download target-ring gerbers' }}
          </button>
        </div>
        <div class="export-row">
          <button class="export-btn" (click)="downloadAssemblyReadme()">Download assembly README</button>
          <span class="export-note">Downloads are never blocked by the tier banners above.</span>
        </div>
          </ng-container>
        </div>
      </ng-container>

    </div>

    <!-- ══════════════════════════════════════════════════════════
         Preview Panel
    ═══════════════════════════════════════════════════════════ -->
    <div class="preview-panel">

      <div class="preview-toolbar">
        <div class="toolbar-left">
          <span class="toolbar-label">Layers:</span>
          <button *ngFor="let layer of layers"
                  class="layer-vis-btn"
                  [class.active]="isLayerVisible(layer.index)"
                  [style.--lc]="layer.color"
                  (click)="toggleLayer(layer.index)">
            <span class="layer-pip" [style.background]="layer.color"></span>
            {{ layer.label }}
          </button>
          <span class="toolbar-label">Show:</span>
          <button class="layer-vis-btn" [class.active]="showVias" (click)="showVias = !showVias">Vias</button>
          <button class="layer-vis-btn" [class.active]="showTerminals" (click)="showTerminals = !showTerminals">Pads</button>
          <button class="layer-vis-btn" [class.active]="showBadges" (click)="showBadges = !showBadges">N/S</button>
          <span class="toolbar-label">Boards:</span>
          <button class="layer-vis-btn" [class.active]="showBoardStator" (click)="showBoardStator = !showBoardStator">Stator</button>
          <button class="layer-vis-btn" [class.active]="showBoardRotor" (click)="showBoardRotor = !showBoardRotor">Rotor</button>
          <button class="layer-vis-btn" *ngIf="encoderEnabled" [class.active]="showBoardEncoder" (click)="showBoardEncoder = !showBoardEncoder">Encoder</button>
          <button class="layer-vis-btn" *ngIf="stackingTabsActive" [class.active]="showGhostStage" (click)="showGhostStage = !showGhostStage">Ghost</button>
        </div>
      </div>

      <div class="svg-container">
        <svg [attr.viewBox]="svgViewBox" class="stator-svg"
             xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">

          <g *ngIf="previewBoardVisible('stator')" class="board-group board-stator">
          <!-- ── Board substrate (eared outline when stacking-tabs is active, else the plain circle) ── -->
          <path *ngIf="stackingTabsActive" [attr.d]="polygonPathD(previewOutline)" class="pcb-substrate"/>
          <circle *ngIf="!stackingTabsActive" cx="0" cy="0" [attr.r]="params.outerRadius" class="pcb-substrate"/>
          <circle cx="0" cy="0" [attr.r]="params.innerRadius" class="pcb-hole"/>

          <!-- ── Per-layer coil arcs and radial steps ── -->
          <ng-container *ngFor="let layer of layers">
            <ng-container *ngIf="isLayerVisible(layer.index)">

              <!-- Meander arcs -->
              <path *ngFor="let a of coilArcsByLayer[layer.index]"
                    [attr.d]="coilArcSvgPath(a)"
                    [attr.stroke]="phaseColors[a.phase]"
                    [attr.stroke-width]="minStrokeWidth"
                    fill="none"
                    stroke-linecap="round"
                    opacity="0.9"/>

              <!-- Radial steps between arcs -->
              <line *ngFor="let t of turnsByLayer[layer.index]"
                    [attr.x1]="t.outerX" [attr.y1]="t.outerY"
                    [attr.x2]="t.innerX" [attr.y2]="t.innerY"
                    [attr.stroke]="phaseColors[t.phase]"
                    [attr.stroke-width]="minStrokeWidth"
                    stroke-linecap="round"
                    opacity="0.9"/>

            </ng-container>
          </ng-container>

          <!-- ── Chaining via markers ── -->
          <g *ngIf="showVias">
            <ng-container *ngFor="let v of vizChainingVias">
              <circle [attr.cx]="v.position.x" [attr.cy]="v.position.y"
                      [attr.r]="minStrokeWidth * 1.2"
                      class="via-marker"/>
            </ng-container>
          </g>

          <!-- ── L3 exit via markers (internal bus taps) ── -->
          <g *ngIf="showTerminals">
            <ng-container *ngFor="let v of vizExitVias">
              <circle [attr.cx]="v.position.x" [attr.cy]="v.position.y"
                      [attr.r]="terminalMarkerR * 0.7"
                      [attr.fill]="phaseColors[v.coilIndex % params.numPhases]"
                      opacity="0.35"
                      class="terminal-marker"/>
              <text [attr.x]="v.position.x" [attr.y]="v.position.y"
                    text-anchor="middle" dominant-baseline="central"
                    fill="#fff" font-weight="700" opacity="0.5"
                    [attr.font-size]="terminalMarkerR * 0.9"
                    class="terminal-label">{{ v.label }}</text>
            </ng-container>
          </g>

          <!-- ── Bridge via markers ── -->
          <g *ngIf="showVias">
            <ng-container *ngFor="let v of busData.bridgeVias">
              <circle [attr.cx]="v.position.x" [attr.cy]="v.position.y"
                      [attr.r]="minStrokeWidth * 1.0"
                      class="via-marker"/>
            </ng-container>
          </g>

          <!-- ── Terminal pad markers (drive + return prominent, internal faint) ──
               'return' (independent/6-lead mode only) is a real solder terminal,
               just like 'drive' — both render at full size/opacity; only 'internal'
               (an in-series junction, not a lead) is faded. Ear joint holes (3 per
               ear, stacking-tabs mode) get a dot each but NO text label here — a
               single compound label per ear is drawn once via `earSilkMarks` below,
               not tripled across the three holes that share one net. ── -->
          <g *ngIf="showTerminals">
            <ng-container *ngFor="let term of vizData.terminals">
              <circle [attr.cx]="term.x" [attr.cy]="term.y"
                      [attr.r]="term.role === 'internal' ? terminalMarkerR * 0.7 : terminalMarkerR * 1.3"
                      [attr.fill]="phaseColors[term.phase]"
                      [attr.opacity]="term.role === 'internal' ? 0.35 : 1"
                      class="terminal-marker"/>
              <text *ngIf="!term.ear" [attr.x]="term.x" [attr.y]="term.y"
                    text-anchor="middle" dominant-baseline="central"
                    fill="#fff" font-weight="700"
                    [attr.opacity]="term.role === 'internal' ? 0.5 : 1"
                    [attr.font-size]="term.role === 'internal' ? terminalMarkerR * 0.9 : terminalMarkerR * 1.3"
                    class="terminal-label">{{ term.role === 'drive' ? driveLabel(term) : term.label }}</text>
            </ng-container>
          </g>

          <!-- ── Silkscreen: phase-drive letter labels beside each drive pad ── -->
          <g *ngIf="showTerminals" class="silk-labels">
            <ng-container *ngFor="let lbl of silkLabels">
              <line *ngFor="let s of lbl.segments"
                    [attr.x1]="s.x1" [attr.y1]="s.y1" [attr.x2]="s.x2" [attr.y2]="s.y2"
                    stroke="#e8e8e8" [attr.stroke-width]="SILK_STROKE_MM"
                    stroke-linecap="round"/>
            </ng-container>
          </g>

          <!-- ── Silkscreen: stacking-tabs ear stage-mating ticks + one compound
               label per ear ('U+'/'U−'/…, not per hole) ── -->
          <g *ngIf="showTerminals && stackingTabsActive" class="silk-labels ear-silk-marks">
            <ng-container *ngFor="let m of earSilkMarks">
              <line [attr.x1]="m.tick.x1" [attr.y1]="m.tick.y1" [attr.x2]="m.tick.x2" [attr.y2]="m.tick.y2"
                    stroke="#e8e8e8" [attr.stroke-width]="SILK_STROKE_MM"
                    stroke-linecap="round"/>
              <line *ngFor="let s of m.labelSegments"
                    [attr.x1]="s.x1" [attr.y1]="s.y1" [attr.x2]="s.x2" [attr.y2]="s.y2"
                    stroke="#e8e8e8" [attr.stroke-width]="SILK_STROKE_MM"
                    stroke-linecap="round"/>
            </ng-container>
          </g>

          <!-- ── Coil magnetic polarity (from emitted geometry) ── -->
          <g *ngIf="showBadges">
            <ng-container *ngFor="let b of coilPolarityBadges">
              <circle [attr.cx]="b.x" [attr.cy]="b.y" [attr.r]="terminalMarkerR * 1.4"
                      [attr.fill]="b.dead ? '#7f1d1d' : 'rgba(0,0,0,0.55)'"
                      [attr.stroke]="phaseColors[b.phase]" [attr.stroke-width]="minStrokeWidth * 0.4"/>
              <text [attr.x]="b.x" [attr.y]="b.y" text-anchor="middle" dominant-baseline="central"
                    [attr.font-size]="terminalMarkerR * 1.8" [attr.fill]="b.dead ? '#fecaca' : phaseColors[b.phase]"
                    font-weight="bold">{{ b.label }}</text>
            </ng-container>
          </g>

          <!-- ── Mounting holes ── -->
          <g class="mounting-holes" *ngIf="mountingHoles > 0">
            <ng-container *ngFor="let h of mountingHoleList">
              <circle [attr.cx]="h.x" [attr.cy]="h.y" [attr.r]="h.keepoutMm"
                      fill="none" stroke="#94a3b8" stroke-width="0.2"
                      stroke-dasharray="0.6 0.6"></circle>
              <circle [attr.cx]="h.x" [attr.cy]="h.y" [attr.r]="h.holeMm / 2"
                      fill="none" stroke="#e2e8f0" stroke-width="0.3"></circle>
            </ng-container>
          </g>

          <!-- ── Dimension rings ── -->
          <circle cx="0" cy="0" [attr.r]="params.outerRadius" class="dim-ring"/>
          <circle cx="0" cy="0" [attr.r]="params.innerRadius" class="dim-ring-inner"/>

          <!-- Margin ring guides -->
          <circle cx="0" cy="0" [attr.r]="coilOuter" class="margin-ring-guide"/>
          <circle cx="0" cy="0" [attr.r]="coilInner" class="margin-ring-guide"/>

          <!-- Bus routing (multi-layer; follows the layer visibility toggles) -->
          <ng-container *ngFor="let a of busData.arcs">
            <path *ngIf="isCopperLayerVisible(a.layer)"
                  [attr.d]="busArcSvgPath(a)"
                  class="bus-trace"
                  [attr.stroke]="busTraceColor(a)"
                  [attr.stroke-width]="minStrokeWidth"
                  opacity="0.9"/>
          </ng-container>
          <ng-container *ngFor="let s of busData.segments">
            <line *ngIf="isCopperLayerVisible(s.layer)"
                  [attr.x1]="s.startX" [attr.y1]="s.startY"
                  [attr.x2]="s.endX"   [attr.y2]="s.endY"
                  [attr.stroke]="busTraceColor(s)"
                  [attr.stroke-width]="minStrokeWidth"
                  stroke-linecap="round"
                  opacity="0.9"/>
          </ng-container>
          <ng-container *ngIf="showTerminals && busData.neutralNode as nn">
            <circle [attr.cx]="nn.x" [attr.cy]="nn.y"
                    [attr.r]="terminalMarkerR * 1.3"
                    class="neutral-node-marker"/>
            <text [attr.x]="nn.x" [attr.y]="nn.y"
                  text-anchor="middle" dominant-baseline="central"
                  fill="#fff" font-weight="700"
                  [attr.font-size]="terminalMarkerR * 1.3"
                  class="terminal-label">N</text>
          </ng-container>
          </g>
          <!-- (end board-stator group) -->

          <!-- ── Ghost overlay: the NEXT stacked board (rotated by one electrical
               period D), so the stacking-tabs mating alignment is visible directly —
               the ghost's + ears should sit exactly on this board's − ears. Preview
               ONLY: the eared outline + ear hole dots + ear labels. NO coils, no
               routing — see `ghostEars`/`ghostOutline`/`ghostEarSilkMarks`. ── -->
          <g *ngIf="ghostStageVisible" class="ghost-stage-preview">
            <path [attr.d]="polygonPathD(ghostOutline)" class="ghost-stage-outline"/>
            <ng-container *ngFor="let ear of ghostEars">
              <circle *ngFor="let h of ear.holes"
                      [attr.cx]="h[0]" [attr.cy]="h[1]"
                      [attr.r]="terminalMarkerR * 0.8"
                      class="ghost-stage-hole"/>
            </ng-container>
            <ng-container *ngFor="let m of ghostEarSilkMarks">
              <line [attr.x1]="m.tick.x1" [attr.y1]="m.tick.y1" [attr.x2]="m.tick.x2" [attr.y2]="m.tick.y2"
                    class="ghost-stage-mark" [attr.stroke-width]="SILK_STROKE_MM"/>
              <line *ngFor="let s of m.labelSegments"
                    [attr.x1]="s.x1" [attr.y1]="s.y1" [attr.x2]="s.x2" [attr.y2]="s.y2"
                    class="ghost-stage-mark" [attr.stroke-width]="SILK_STROKE_MM"/>
            </ng-container>
          </g>

          <!-- ── Rotor-disc overlay (magnet pockets, bore, pole-0 notch) ── -->
          <g *ngIf="previewBoardVisible('rotor') && rotorLayout.valid" class="rotor-preview">
            <circle cx="0" cy="0" [attr.r]="rotorLayout.discOuterRadiusMm"
                    fill="none" stroke="#fbbf24" stroke-width="0.4" stroke-dasharray="2 1.5"/>
            <circle cx="0" cy="0" [attr.r]="rotorLayout.boreRadiusMm"
                    fill="none" stroke="#fbbf24" stroke-width="0.4" stroke-dasharray="2 1.5"/>
            <ng-container *ngFor="let m of rotorLayout.magnets">
              <circle *ngIf="rotorMagnetShape === 'round'"
                      [attr.cx]="m.cx" [attr.cy]="m.cy" [attr.r]="$any(m.pocketMm).dia / 2"
                      fill="rgba(251,191,36,0.12)" stroke="#fbbf24" stroke-width="0.3"/>
              <rect *ngIf="rotorMagnetShape === 'rect'"
                    [attr.x]="m.cx - $any(m.pocketMm).length / 2" [attr.y]="m.cy - $any(m.pocketMm).width / 2"
                    [attr.width]="$any(m.pocketMm).length" [attr.height]="$any(m.pocketMm).width"
                    [attr.transform]="'rotate(' + m.angleDeg + ' ' + m.cx + ' ' + m.cy + ')'"
                    fill="rgba(251,191,36,0.12)" stroke="#fbbf24" stroke-width="0.3"/>
              <text [attr.x]="m.cx" [attr.y]="m.cy" text-anchor="middle" dominant-baseline="central"
                    font-size="4" fill="#fbbf24">{{ m.polarity }}</text>
            </ng-container>
            <line *ngIf="rotorNotchLine as t"
                  [attr.x1]="t.x1" [attr.y1]="t.y1" [attr.x2]="t.x2" [attr.y2]="t.y2"
                  stroke="#fbbf24" stroke-width="0.8"/>
          </g>

          <!-- ── Target ring (fine/coarse copper lobes + recess outline) — part of the
               rotor board group: the target glues to the rotor's back face. ── -->
          <g *ngIf="previewBoardVisible('rotor') && encoderEnabled && encoderBands.valid" class="target-ring-preview">
            <path *ngFor="let lobe of targetRing.lobes"
                  [attr.d]="polygonPathD(lobe.polygon)"
                  [attr.fill]="lobe.track === 'fine' ? '#4ade80' : '#818cf8'"
                  opacity="0.5" stroke="none"/>
            <path *ngIf="rotorLayout.recess as rc"
                  [attr.d]="'M ' + rc.rOutMm + ' 0 A ' + rc.rOutMm + ' ' + rc.rOutMm + ' 0 1 1 ' + (-rc.rOutMm) + ' 0 A ' + rc.rOutMm + ' ' + rc.rOutMm + ' 0 1 1 ' + rc.rOutMm + ' 0'"
                  fill="none" stroke="#fbbf24" stroke-width="0.3" stroke-dasharray="1 1"/>
          </g>

          <!-- ── Encoder-ring board: sensing coils + (once solved) escape routes + pads ── -->
          <g *ngIf="previewBoardVisible('encoder')" class="board-group board-encoder">
            <path *ngFor="let t of sensingElement.traces"
                  [attr.d]="tracePathD(t.points)"
                  fill="none"
                  [attr.stroke]="encoderNetColor(t.net)"
                  [attr.stroke-width]="t.widthMm"
                  [attr.opacity]="t.layer === 'up' ? 0.9 : 0.55"
                  stroke-linecap="round"/>
            <ng-container *ngIf="encoderBoard as eb">
              <path *ngFor="let r of eb.routes"
                    [attr.d]="tracePathD(r.points)"
                    fill="none"
                    [attr.stroke]="encoderNetColor(r.net)"
                    [attr.stroke-width]="r.widthMm"
                    [attr.opacity]="r.layer === 'up' ? 0.9 : 0.55"
                    stroke-linecap="round"/>
              <ng-container *ngFor="let fp of eb.placements">
                <rect *ngFor="let pad of fp.pads"
                      [attr.x]="pad.at[0] - pad.wMm / 2" [attr.y]="pad.at[1] - pad.hMm / 2"
                      [attr.width]="pad.wMm" [attr.height]="pad.hMm"
                      fill="#e2e8f0" opacity="0.85"/>
              </ng-container>
            </ng-container>
          </g>

          <!-- Crosshair -->
          <line [attr.x1]="-params.outerRadius * 0.04" y1="0"
                [attr.x2]="params.outerRadius * 0.04"  y2="0" class="crosshair"/>
          <line x1="0" [attr.y1]="-params.outerRadius * 0.04"
                x2="0" [attr.y2]="params.outerRadius * 0.04"  class="crosshair"/>

        </svg>
      </div>

      <!-- Legend bar -->
      <div class="preview-legend-bar">
        <div class="legend-entry">
          <span class="legend-swatch arc-swatch"></span>
          <span>Meander arcs (phase-colored)</span>
        </div>
        <div class="legend-entry">
          <span class="legend-swatch fcu-swatch"></span>
          <span>Radial steps (arc connections)</span>
        </div>
        <div class="legend-entry">
          <span class="legend-swatch via-swatch"></span>
          <span>Through-hole vias (chaining + bridge)</span>
        </div>
        <div class="legend-entry">
          <span class="info-tag">{{ params.numCoils }}C/{{ params.numPoles }}P</span>
          <span>{{ params.numCoils }} coils, {{ params.numPoles }} magnet poles</span>
        </div>
        <div class="legend-entry">
          <span class="info-tag">{{ turnsPerLayer }}T</span>
          <span>{{ turnsPerLayer }} turns/coil, {{ params.numLayers }}-layer series chain</span>
        </div>
        <div class="legend-entry" *ngIf="windingType">
          <span class="info-tag">{{ windingType === 'wye' ? 'Y' : (windingType === 'delta' ? '&#916;' : '6L') }}</span>
          <span>{{ windingType === 'wye' ? 'Wye winding' : (windingType === 'delta' ? 'Delta winding' : 'Independent (6-lead) winding') }}</span>
        </div>
        <div class="legend-entry">
          <span class="legend-swatch" style="background: #cbd5e1;"></span>
          <span>Bus routing (F_Cu)</span>
        </div>
        <div class="legend-entry" *ngIf="windingType === 'wye'">
          <span class="legend-swatch" style="background: #f8fafc; border: 1px solid #1e293b;"></span>
          <span>Neutral node</span>
        </div>
        <div class="legend-entry" *ngIf="windingType === 'independent'">
          <span class="legend-swatch" style="background: #f8fafc; border: 1px solid #1e293b;"></span>
          <span>Return (&minus;) pad: each phase's free end, brought out as its own solder terminal (no bus)</span>
        </div>
        <div class="legend-entry" *ngIf="stackingTabsActive">
          <span class="legend-swatch" style="background: #e8e8e8;"></span>
          <span>Ear (stacking tabs): 3-hole joint beyond the board edge, tick + label mark the stage-mating seam &mdash; identical boards rotated {{ stackStageDeg | number:'1.0-1' }}&deg;/stage solder together here</span>
        </div>
        <div class="legend-entry" *ngIf="ghostStageVisible">
          <span class="legend-swatch" style="background: transparent; border: 1px dashed var(--ghost-stage-color);"></span>
          <span>Ghost (next stage): board rotated {{ stackStageDeg | number:'1.0-1' }}&deg; &mdash; its + ears (labeled) should land exactly on this board's &minus; ears</span>
        </div>
        <div class="legend-entry" *ngIf="previewBoardVisible('rotor')">
          <span class="legend-swatch" style="background: rgba(251,191,36,0.3); border: 1px dashed #fbbf24;"></span>
          <span>Rotor overlay: disc rim/bore, magnet pockets (N/S), pole-0 notch</span>
        </div>
        <div class="legend-entry" *ngIf="encoderEnabled && showBoardRotor">
          <span class="legend-swatch" style="background: rgba(74,222,128,0.5);"></span>
          <span>Target-ring lobes (fine = green, coarse = indigo) + recess outline</span>
        </div>
        <div class="legend-entry" *ngIf="encoderEnabled && showBoardEncoder">
          <span class="legend-swatch" style="background: var(--board-encoder-color);"></span>
          <span>Encoder-ring coils (TX amber, fine-RX green, coarse-RX indigo) + escape routing</span>
        </div>
      </div>

    </div>
  </div>

    <div class="stats-footer" [class.collapsed]="statsCollapsed">
      <div class="stats-footer-bar">
        <button type="button" class="stats-footer-toggle" (click)="statsCollapsed = !statsCollapsed">
          <span class="chevron">{{ statsCollapsed ? '&#9656;' : '&#9662;' }}</span> Calculated
        </button>
        <button type="button" class="layer-btn" (click)="openLegend(legendModal)">&#9432; Legend — what do these mean?</button>
        <button type="button" class="layer-btn" (click)="openSavedModal(savedPcbsModal)">&#128190; Saved PCBs</button>
      </div>
      <ng-container *ngIf="!statsCollapsed">
      <div class="stats-panel">
        <div class="stats-title">Calculated</div>
        <div class="stat-row">
          <span class="stat-label">Board Diameter</span>
          <span class="stat-value">{{ params.outerRadius * 2 }} mm</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Sector angle</span>
          <span class="stat-value">{{ sectorAngleDeg | number:'1.1-1' }}&#176;</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Turns / coil (auto)
            <span class="help-i" [ngbTooltip]="help('turnsPerCoil')" container="body">&#9432;</span></span>
          <span class="stat-value" [class.stat-warn]="!turnsValid">{{ turnsPerLayer }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Radial limit
            <span class="help-i" [ngbTooltip]="help('radialLimit')" container="body">&#9432;</span></span>
          <span class="stat-value">{{ turnLimits.radial }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Angular limit
            <span class="help-i" [ngbTooltip]="help('angularLimit')" container="body">&#9432;</span></span>
          <span class="stat-value">{{ turnLimits.angular }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Coils / phase</span>
          <span class="stat-value">{{ coilsPerPhase }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Radial depth
            <span class="help-i" [ngbTooltip]="help('radialDepth')" container="body">&#9432;</span></span>
          <span class="stat-value">{{ radialDepthMm | number:'1.1-1' }} mm</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">R / phase <span class="approx">~</span>
            <span class="help-i" [ngbTooltip]="help('resistancePerPhase')" container="body">&#9432;</span></span>
          <span class="stat-value">{{ formatOhms(estimatedResistancePerPhaseOhm) }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">L / phase <span class="approx">~</span>
            <span class="help-i" [ngbTooltip]="help('inductancePerPhase')" container="body">&#9432;</span></span>
          <span class="stat-value">{{ formatHenry(estimatedInductancePerPhaseH) }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Max current <span class="approx">~</span>
            <span class="help-i" [ngbTooltip]="help('maxCurrent')" container="body">&#9432;</span></span>
          <span class="stat-value">{{ currentRating.internalAmps | number:'1.2-2' }} A</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">ext. layer
            <span class="help-i" [ngbTooltip]="help('extLayerCurrent')" container="body">&#9432;</span></span>
          <span class="stat-value">{{ currentRating.externalAmps | number:'1.2-2' }} A</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Voltage const
            <span class="help-i" [ngbTooltip]="help('voltageConst')" container="body">&#9432;</span></span>
          <span class="stat-value">{{ voltageData.kePhaseVperKrpm | number:'1.2-2' }} V/1000rpm</span>
        </div>
        <div class="stat-row" *ngIf="windingType !== 'independent'">
          <span class="stat-label">V/phase <span class="approx">~</span>
            <span class="help-i" [ngbTooltip]="help('phaseVoltage')" container="body">&#9432;</span></span>
          <span class="stat-value">{{ voltageData.phaseRmsV | number:'1.2-2' }} V</span>
        </div>
        <div class="stat-row" *ngIf="windingType !== 'independent'">
          <span class="stat-label">V line-line <span class="approx">~</span>
            <span class="help-i" [ngbTooltip]="help('lineVoltage')" container="body">&#9432;</span></span>
          <span class="stat-value">{{ voltageData.lineRmsV | number:'1.2-2' }} V</span>
        </div>
        <ng-container *ngIf="windingType === 'independent'">
        <div class="stat-row">
          <span class="stat-label">{{ voltageDisplay.primaryLabel }} <span class="approx">~</span>
            <span class="help-i" [ngbTooltip]="help('phaseVoltage')" container="body">&#9432;</span></span>
          <span class="stat-value">{{ voltageDisplay.primary | number:'1.2-2' }} V</span>
        </div>
        <div class="stat-row" *ngFor="let scenario of voltageDisplay.scenarios">
          <span class="stat-label">{{ scenario.label }} <span class="approx">~</span></span>
          <span class="stat-value">{{ scenario.value | number:'1.2-2' }} V</span>
        </div>
        </ng-container>
        <div class="stat-row">
          <span class="stat-label">Winding factor
            <span class="help-i" [ngbTooltip]="help('windingFactor')" container="body">&#9432;</span></span>
          <span class="stat-value" [class.stat-warn]="windingFactorLow">{{ windingFactors[0] | number:'1.2-2' }}</span>
        </div>
      </div>
      <div class="param-row" *ngIf="windingFactorLow">
        <span class="warn-badge">&#9888; Winding factor {{ windingFactors[0] | number:'1.2-2' }} — this
          coils/poles combination wastes most of the copper. Try a pole count nearer the coil count.</span>
      </div>
      <p class="stats-footnote">MMF per coil = turns × numLayers × I ({{ params.numLayers }}-layer series chain).</p>
      <p class="stats-footnote">Voltage: open-circuit, winding factor {{ voltageData.kw | number:'1.2-2' }} applied; set Air-gap flux to your magnet/gap.</p>
      <p class="stats-footnote" *ngIf="windingType === 'independent'">Independent mode has no internal star/delta connection, so there is no line-to-line voltage until you wire the six leads externally — the rows above are labeled what-if scenarios, not measured terminals.</p>
      </ng-container>
    </div>
</div>

<ng-template #legendModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">PCB Stator — option guide</h5>
    <!-- Bootstrap 4 close markup (.btn-close is BS5-only and renders invisible with the BS4 CSS this app ships) -->
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body legend-body">
    <div class="legend-section" *ngFor="let s of helpSections">
      <h6 class="legend-section-title">{{ s.title }}</h6>
      <div class="legend-row" *ngFor="let e of s.entries">
        <span class="legend-label">{{ e.label }}</span>
        <span class="legend-blurb">{{ e.blurb }}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #savedPcbsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Saved PCBs</h5>
    <!-- Bootstrap 4 close markup (.btn-close is BS5-only and renders invisible with the BS4 CSS this app ships) -->
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body saved-body">

    <!-- Save current -->
    <div class="saved-save-row">
      <input type="text" class="form-control saved-name-input"
             [ngModel]="suggestedName()" #nameInput
             placeholder="Name this configuration" />
      <button type="button" class="btn btn-primary"
              (click)="saveCurrent(nameInput.value)">Save current</button>
    </div>

    <!-- List -->
    <div class="saved-empty" *ngIf="savedConfigs.length === 0">
      No saved PCBs yet. Set your dimensions, then hit “Save current”.
    </div>

    <div class="saved-item" *ngFor="let cfg of savedConfigs">
      <div class="saved-item-main">
        <div class="saved-item-name">{{ cfg.name }}</div>
        <div class="saved-item-inputs">
          {{ cfg.inputs.params.outerRadius * 2 }}mm ·
          {{ cfg.inputs.params.numPhases }}φ ·
          {{ cfg.inputs.params.numPoles }}P ·
          {{ cfg.inputs.windingType }} ·
          {{ cfg.inputs.params.numLayers }}-layer
        </div>
        <div class="saved-item-stats">
          R/phase {{ cfg.headlineStats.resistancePerPhaseOhm | number:'1.2-2' }}Ω ·
          V line-line {{ cfg.headlineStats.lineVoltageRms | number:'1.1-1' }}V
        </div>
        <div class="saved-item-date">{{ cfg.createdAt | date:'short' }}</div>
      </div>
      <div class="saved-item-actions">
        <button type="button" class="btn btn-sm btn-primary"
                (click)="loadConfig(cfg); modal.close()">Load</button>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="renameSaved(cfg.id, promptRename(cfg.name))">Rename</button>
        <button type="button" class="btn btn-sm btn-outline-danger"
                (click)="confirmRemove(cfg)">Delete</button>
      </div>
    </div>

  </div>
</ng-template>
